import _u from '../utils';

class BufferedEventQueue {
    constructor(dispatch, {
        queueSize = 20,
        dispatchTimeoutMs = 10000,
    } = {}) {
        if (!dispatch) {
            throw new Error('missing required parameter \'dispatch\'');
        }

        if (queueSize <= 1) {
            throw new Error(`'queueSize = ${queueSize}' is not supported`);
        }

        this.queueSize = queueSize;
        this.dispatchTimeoutMs = dispatchTimeoutMs;
        this.dispatch = dispatch;

        this._queue = [];
        this._dispatchTimeoutId = undefined;
    }

    push(value) {
        if (this._queue.length >= this.queueSize) {
            this._dispatch();
        }

        this._queue.push(value);
        this._scheduleDispatch();
    }

    flush() {
        this._dispatch();
    }

    truncate() {
        this._clearTimeout();
        return _u.truncate(this._queue);
    }

    _scheduleDispatch() {
        if (!this._dispatchTimeoutId) {
            this._dispatchTimeoutId = setTimeout(() => this._dispatch(), this.dispatchTimeoutMs);
        }
    }

    _dispatch() {
        this._clearTimeout();

        if (this._queue.length) {
            this.dispatch(_u.truncate(this._queue));
        }
    }

    _clearTimeout() {
        clearTimeout(this._dispatchTimeoutId);
        this._dispatchTimeoutId = undefined;
    }
}

export {BufferedEventQueue};
